module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "telTest"
    }
  }, [(_vm.show_type === 2 || _vm.show_type == 3) ? _c('div', {
    staticClass: "tishi"
  }, [_c('p', {
    staticStyle: {
      "font-size": "25px",
      "font-weight": "549",
      "color": "#313541",
      "line-height": "35px"
    }
  }, [_vm._v("\n\t\t\t白名单观看\n\t\t")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "20px",
      "margin-top": "5px",
      "color": "#7B838E"
    }
  }, [_vm._v("\n\t\t\t只允许添加了白名单的用户观看\n\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.show_type === 1) ? _c('div', {
    staticClass: "tishi"
  }, [_c('p', {
    staticStyle: {
      "font-size": "25px",
      "font-weight": "549",
      "color": "#313541",
      "line-height": "35px"
    }
  }, [_vm._v("\n\t\t\t登记信息\n\t\t")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "20px",
      "margin-top": "5px",
      "color": "#7B838E"
    }
  }, [_vm._v("\n\t\t\t为了保障课程知识产权，需登记学员信息核实后即可观看\n\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.show_type === 2) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('span', {
    staticClass: "content-box_span"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('input', {
    staticClass: "content-box_input",
    attrs: {
      "placeholder": "请输入内容",
      "type": "number"
    },
    domProps: {
      "value": _vm.phone
    },
    on: {
      "input": function($event) {
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.need_check_bool) ? _c('div', {
    staticClass: "content-box"
  }, [_c('span', {
    staticClass: "content-box_span"
  }, [_vm._v("验证码")]), _vm._v(" "), _c('input', {
    staticClass: "content-box_input",
    attrs: {
      "placeholder": "请输入内容"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.phone_text == '获取验证码') ? _c('button', {
    staticClass: "content-box_code_buttom",
    on: {
      "click": function($event) {
        return _vm.sendMsg(_vm.phone, 2)
      }
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.phone_text) + "\n\t\t\t")]) : _c('button', {
    staticClass: "content-box_code_buttom",
    staticStyle: {
      "background-color": "#fff",
      "color": "#afafaf",
      "border": "1px solid #afafaf"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.phone_text) + "\n\t\t\t")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show_type === 3) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('span', {
    staticClass: "content-box_span"
  }, [_vm._v("账号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account_white_name),
      expression: "account_white_name"
    }],
    staticClass: "content-box_input",
    attrs: {
      "placeholder": "请输入账号",
      "type": "text"
    },
    domProps: {
      "value": (_vm.account_white_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account_white_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-box"
  }, [_c('span', {
    staticClass: "content-box_span"
  }, [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account_white_password),
      expression: "account_white_password"
    }],
    staticClass: "content-box_input",
    attrs: {
      "placeholder": "请输入密码",
      "type": "text"
    },
    domProps: {
      "value": (_vm.account_white_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account_white_password = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.show_type === 1) ? _c('div', {
    staticStyle: {
      "margin": "30px 0 0 0px"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index
    }, [(item.type == 1) ? _c('div', [_c('div', {
      staticClass: "content-box"
    }, [_c('span', {
      staticClass: "content-box_span"
    }, [(item.is_field == 'yes') ? _c('span', {
      staticClass: "content-box_title",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("* ")]) : _vm._e(), _vm._v(_vm._s(item.name_title))]), _vm._v(" "), _c('input', {
      staticClass: "content-box_input",
      attrs: {
        "type": "number",
        "placeholder": "请输入内容"
      },
      domProps: {
        "value": item.value
      },
      on: {
        "input": function($event) {
          return _vm.inputChange(item, index, $event)
        }
      }
    })]), _vm._v(" "), (item.is_phone_check == 'yes') ? _c('div', {
      staticClass: "content-box"
    }, [_c('span', {
      staticClass: "content-box_span"
    }, [(item.is_field == 'yes') ? _c('span', {
      staticClass: "content-box_title",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("* ")]) : _vm._e(), _vm._v("验证码")]), _vm._v(" "), _c('input', {
      staticClass: "content-box_input",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": item.code
      },
      on: {
        "input": function($event) {
          item.code = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.phone_text == '获取验证码') ? _c('button', {
      staticClass: "content-box_code_buttom",
      attrs: {
        "placeholder": "请输入内容"
      },
      on: {
        "click": function($event) {
          return _vm.sendMsg(item.value, 1)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.phone_text) + "\n\t\t\t\t\t")]) : _c('button', {
      staticClass: "content-box_code_buttom",
      staticStyle: {
        "background-color": "#fff",
        "color": "#afafaf",
        "border": "1px solid #afafaf"
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.phone_text) + "\n\t\t\t\t\t")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.type == 2) ? _c('div', {
      staticStyle: {
        "border-bottom": "#e5e5e5 solid 1px",
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('span', {
      staticClass: "content-box_span"
    }, [(item.is_field == 'yes') ? _c('span', {
      staticClass: "content-box_title",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("* ")]) : _vm._e(), _vm._v(_vm._s(item.name_title))]), _vm._v(" "), _c('input', {
      staticClass: "content-box_input",
      attrs: {
        "placeholder": "请输入内容"
      },
      domProps: {
        "value": item.value
      },
      on: {
        "input": function($event) {
          item.value = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), (item.type == 3) ? _c('div', {
      staticStyle: {
        "border-bottom": "#e5e5e5 solid 1px",
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('span', {
      staticClass: "content-box_span"
    }, [(item.is_field == 'yes') ? _c('span', {
      staticClass: "content-box_title",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("* ")]) : _vm._e(), _vm._v(_vm._s(item.name_title))]), _vm._v(" "), _c('input', {
      staticClass: "content-box_input",
      attrs: {
        "placeholder": "请输入内容"
      },
      domProps: {
        "value": item.value
      },
      on: {
        "input": function($event) {
          item.value = $event.target.value
        }
      }
    })]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "80px",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "bottom": "0px",
      "left": "0px",
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "80%",
      "display": "inline-block"
    },
    attrs: {
      "type": "primary",
      "size": "large",
      "block": ""
    },
    on: {
      "click": _vm.commitData
    }
  }, [_vm._v("进入观看\n\t\t")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-030933f8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/telTest.vue
// module id = 371
// module chunks = 0